import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { validateEmail } from '@/components/portfolio/settings/utils/validationUtils';

interface UserDetailsSectionProps {
  email: string;
  handleEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  termsAccepted: boolean;
  handleTermsChange: (checked: boolean) => void;
  marketingOptIn: boolean;
  handleMarketingChange: (checked: boolean) => void;
}

const UserDetailsSection: React.FC<UserDetailsSectionProps> = ({
  email,
  handleEmailChange,
  termsAccepted,
  handleTermsChange,
  marketingOptIn,
  handleMarketingChange
}) => {
  const [emailTouched, setEmailTouched] = useState(false);
  
  // Add console logs for debugging
  console.log("[UserDetailsSection] Email prop received:", `'${email}'`);
  const validationResult = email ? validateEmail(email) : "Email prop is empty or null";
  console.log("[UserDetailsSection] validateEmail result:", validationResult);
  
  const isValidEmail = email && validateEmail(email) === undefined; // Corrected from null to undefined
  console.log("[UserDetailsSection] isValidEmail calculated as:", isValidEmail);
  
  const showCheckboxes = emailTouched && isValidEmail;
  
  const handleEmailBlur = () => {
    setEmailTouched(true);
    console.log("[UserDetailsSection] Email blurred. Touched: true");
  };
  
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <div className="flex justify-between">
          <label htmlFor="userEmail" className="text-sm font-medium">Email Address</label>
          {emailTouched && email && !isValidEmail && (
            <span className="text-xs text-red-500">Please enter a valid email</span>
          )}
        </div>
        <Input
          id="userEmail"
          name="userEmail"
          type="email"
          value={email}
          onChange={handleEmailChange}
          onBlur={handleEmailBlur}
          placeholder="your.email@example.com"
          className={`px-4 ${emailTouched && email && !isValidEmail ? 'border-red-500 focus-visible:ring-red-500' : ''}`}
        />
        <p className="text-xs text-gray-500">
          We'll use this email to create your account and send you important updates.
        </p>
      </div>

      {showCheckboxes && (
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="terms" 
              checked={termsAccepted}
              onCheckedChange={handleTermsChange}
            />
            <Label htmlFor="terms" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
              I approve gozango's terms and conditions
            </Label>
          </div>
          
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="marketing" 
              checked={marketingOptIn}
              onCheckedChange={handleMarketingChange}
            />
            <Label htmlFor="marketing" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
              I want to receive upcoming updates and promotions
            </Label>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDetailsSection;
